"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getBrandValue = _interopRequireDefault(require("./getBrandValue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var hyphenatedExceptions = ['my-telus'];
var applyExceptions = function applyExceptions(string) {
  var formattedName = string;
  hyphenatedExceptions.forEach(function (exception) {
    var search = exception.replace(/-/g, '_');
    var regex = new RegExp(search, 'g');
    formattedName = formattedName.replace(regex, exception);
  });
  return formattedName;
};
var getSections = function getSections(customPageName) {
  if (customPageName) {
    return customPageName.split('>').slice(1);
  }
  var formatted = window.location.pathname.replace(/^\/|\/$/g, '').replace(/^(en|fr|de|pl|tr|jp)(\/(nl|pe|ns|nb|qc|on|mb|sk|ab|bc|yt|nt|nu))?\//, '').replace(/\/account\/\w{22}(\/subscriber\/\w{22})?/g, '').replace(/\//g, '>').replace(/-/g, '_');
  return applyExceptions(formatted).split('>');
};
var getPageNameValues = function getPageNameValues(customPageName, contentName) {
  var prefix = (0, _getBrandValue["default"])({
    telus: 'telus',
    koodo: 'koodo_mobile',
    ngc: 'cse'
  });
  var sections = getSections(customPageName);
  var pageName = "".concat(prefix, ">").concat(sections.join('>')).concat(contentName ? ">".concat(contentName) : '');
  return {
    pageName: pageName,
    customSiteSection: sections[0],
    primarySiteSection: sections[1],
    secondarySiteSection: sections[2],
    tertiarySiteSection: sections[3],
    quaternarySiteSection: sections[4]
  };
};
var _default = exports["default"] = getPageNameValues;